import { useState } from 'react';
import { SharedInteractionsQuickSearchProps } from './Types/componentProps';
import { sharedInteractionsSearchCategories } from './Utils/constants';
import CollaborationSharedQuickSearch from './Shared/CollaborationSharedQuickSearch';
import { TrackerDataType } from '../../shared/constants/constants';

const SharedInteractionsQuickSearch = (props: SharedInteractionsQuickSearchProps) => {
  const { onSearch } = props;
  const [selectedCategory, setSelectedCategory] = useState<string>(sharedInteractionsSearchCategories[0].value);
  const [searchText, setSearchText] = useState('');

  const handleClickSearch = () => {
    onSearch(selectedCategory, searchText);
  };

  const handleClickClear = () => {
    setSearchText('');
    onSearch('', '');
  };

  return (
    <CollaborationSharedQuickSearch
      searchCategoryOptions={sharedInteractionsSearchCategories}
      selectedCategory={selectedCategory}
      onSelectedCategoryChange={setSelectedCategory}
      searchText={searchText}
      onSearchTextChange={setSearchText}
      onSearchButtonClick={handleClickSearch}
      onClearButtonClick={handleClickClear}
      type={TrackerDataType.MEDIA_INTERACTION}
    />
  );
};

export default SharedInteractionsQuickSearch;
